import React from 'react';
import { useTranslation } from 'react-i18next';
import { BOOL } from '@tencent/wemeet-websdk-next';

import wemeetClient from '@utils/wemeetClient';

import { HostVideoCtrlProps } from './HostVideoCtrl.type';

import './HostVideoCtrl.scss';

const HostVideoCtrl: React.FC<HostVideoCtrlProps> = (props) => {
  const { t } = useTranslation();

  const muteVideo = () => {
    if (props.user.id) {
      wemeetClient.hostCtrl.muteVideo(props.user.id, BOOL.false);
    }
  };

  return (
    <li className="host-video-ctrl" onClick={muteVideo}>
      {t('停止视频')}
    </li>
  );
};

export default HostVideoCtrl;
